import {UserCreationRolesProvider} from '@hconnect/adminconsole/src/contexts/UserCreationRolesContext'
import {ManageUser} from '@hconnect/adminconsole/src/pages/ManageUser/ManageUser'
import {User} from '@hconnect/apiclient'
import {withRoute} from '@hconnect/uikit'
import {useSelector} from 'react-redux'

import {usePermissions} from '../../Permissions'
import {AppState} from '../../Root.store'

const ManageUserPage = () => {
  const {adminConsoleGrantedPermissionTypes} = usePermissions()
  const loggedInUserProfile = useSelector<AppState, User | null>(
    (state) => state.userProfile.userProfile
  )
  return (
    <UserCreationRolesProvider>
      <ManageUser
        loggedInUserPermissions={adminConsoleGrantedPermissionTypes}
        loggedInUserProfile={loggedInUserProfile}
      />
    </UserCreationRolesProvider>
  )
}

export const ROUTE = '/manage'

withRoute({
  path: ROUTE,
  hideInMainNav: true
})(() => null)

export default withRoute({
  path: `${ROUTE}/:userId`,
  label: 'Manage User',
  hideInMainNav: true,
  routeProps: {exact: true}
})(ManageUserPage)
